module.exports = __webpack_public_path__ + "img/a2.a5e385d8.jpg";